import { z } from "zod"

export const ZLocalUserActivity = z.object({
  name: z.string(),
  entityType: z.literal("sheet"),
  timestamp: z.number(),
})
